<template>
  <PageWrapper
    :active-section="SECTION_COMMUNITY"
    :active-page="PAGE_MARKETING_STRATEGISTS"
    title="Marketing Strategists"
    sub-title=""
    :breadcrumbs="breadcrumbs"
    page-name="Marketing Strategists"
    align="left"
    width="fixed"
  >
    <SmartFeed
      :source="useOrgCommunityMarketingExpertiseFeedStore"
      default-entity-size="large"
      default-feed-layout="grid"
      load-more-behavior="auto"
      :show-filters="false"
    >
      <template #empty-state>
        <iSpace :height="10" />
        <iColumn gap="large" align="center">
          <iColumn gap="standard" align="center">
            <iSubHeading variant="subtle" font-size="large">
              No marketing strategists found
            </iSubHeading>
            <iParagraph
              variant="subtle"
              text-align="center"
              :max-width="400"
            >
              There are currently no marketing strategists available in the community
            </iParagraph>
          </iColumn>
        </iColumn>
      </template>
    </SmartFeed>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  SECTION_COMMUNITY,
  PAGE_MARKETING_STRATEGISTS,
} from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import {
  useOrgCommunityMarketingExpertiseFeedStore,
} from "SmartFeed/stores/feed/org-community-marketing-expertise-feed-store";

export default {
  name: "MarketingStrategists",
  components: {
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_MARKETING_STRATEGISTS,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
        { url: "/experts", label: "Experts" },
      ];
    },
  },
  methods: { useOrgCommunityMarketingExpertiseFeedStore },
};
</script>
